module.exports = __webpack_public_path__ + "img/beijin.6c9c161c.png";